export default "__VITE_ASSET__CMeYQ_9k__"